// Module
var code = "<portal to=\"alert\"> <div :key=\"uniqueId\" class=\"alert-container\"> <div class=\"alert-slot\" style=\"max-width:600px\"> <slot></slot> <slot name=\"buttons\"> <button @click=\"close()\" class=\"btn btn-primary\">Okay</button> </slot> </div> </div> </portal> ";
// Exports
export default code;